module.exports = __webpack_public_path__ + "img/cover-product-mob.684290f.webp";